import { SelectionState } from "types";
import create from "zustand";
import { InventoryStatus } from "@/components/Product/MerchandiseInventory/InventoryStatusFilter";

const defaultMerchandiseSelection: SelectionState = { all: true, selected: [] };

interface MerchandiseInventoryFilterState {
    search: string;
    merchandiseSelection: SelectionState;
    statusFilter: InventoryStatus;
    setSearch: (search: string) => void;
    setMerchandiseSelection: (selection: SelectionState) => void;
    setStatusFilter: (status: InventoryStatus) => void;
}

export const useMerchandiseInventoryFilterStore = create<MerchandiseInventoryFilterState>((set) => ({
    search: "",
    merchandiseSelection: defaultMerchandiseSelection,
    statusFilter: "published",
    setSearch: (search) => set({ search }),
    setMerchandiseSelection: (merchandiseSelection) => set({ merchandiseSelection }),
    setStatusFilter: (statusFilter) => set({ statusFilter }),
}));
